import React, { useState } from 'react'
import classNames from 'classnames'
import queryString from 'query-string'

import Modal from 'sharedComponents/Modal'

import style from './style.module.scss'
import api from 'services/pet-notify-api'


function DeleteAddressModal(props: any) {
    const { onClose, addressId, addressName } = props
    console.log("🚀 ~ DeleteAddressModal ~ props:", props.location.pathname)
    const isSuccessPage = props.location.pathname === `/manage-address/delete/${addressId}/${addressName}`
    console.log("🚀 ~ DeleteAddressModal ~ isSuccessPage:", isSuccessPage)
    // const isSuccessPage = props.location.pathname === `/order-intellitag/success`
    const { mobile } = queryString.parse(location.search)
    const isMobile = mobile === 'true'
    const [isDeleting, setIsDeleting] = useState(false)

    const handleDeleteAddress = async () => {
        try {
            setIsDeleting(true)
            const response = await api.address.remove(addressId)
            console.log(response)
            onClose()
        } catch (error) {
            console.error('Error deleting intellitag:', error)
        } finally {
            setIsDeleting(false)
        }
    }
    
    return (
        <Modal
            onClose={onClose}
            showCloseButton={isSuccessPage}
            className={classNames(style.wrapper, {
                [style.successModal]: isSuccessPage,
                [style.isFullscreen]: isMobile,
            })}
            disableClickOffToClose
            isFullscreen={isMobile}
        >
            <div className={style.content}>
                <h2>Delete Address</h2>
                <p style={{ marginBottom: '10px' }}>You’re requesting to delete address for {addressName}.</p>
                <p>Click DELETE to confirm</p>

                <div className={style.buttons}>
                    <button
                        className={style.cancelButton}
                        onClick={onClose}
                        disabled={isDeleting}
                    >
                        No, Keep Address
                    </button>
                    <button
                        className={style.confirmButton}
                        disabled={isDeleting}
                        onClick={handleDeleteAddress}
                    >
                       Yes, Delete Address
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteAddressModal